export default __webpack_public_path__ + "static/media/darkHardAcclerate.490486f4.png";